import { Record, List } from 'immutable';
import { construct, fields, resolveAll, resolve } from '../helpers/LinkMapper';
import ReservationSeat from './ReservationSeat';
import ReservationStation from './ReservationStation';
import { RESERVATION_NOT_POSSIBLE } from '../constants/AppConstants';
import trainTime from '../lib/TrainTime';

const ReservationLeg = new Record({
    arrival: null,
    departure: null,
    origin: new ReservationStation(),
    destination: new ReservationStation(),
    retailServiceId: null,
    seats: new List(),
    bikeSeats: new List(),
    supplement: null,
    ticketType: null,
    seatReservation: null,
    bikeSeatReservation: null,
});

Object.assign(ReservationLeg.prototype, {
    getDepartureTime() {
        return this.departure ? trainTime(this.departure).format('HH:mm') : null;
    },

    getArrivalTime() {
        return this.arrival ? trainTime(this.arrival).format('HH:mm') : null;
    },

    getOriginName() {
        return this.origin.name;
    },

    getDestinationName() {
        return this.destination.name;
    },

    isSeatReservationUnavailable() {
        return this.isSeatReservation() && this.seatReservation === RESERVATION_NOT_POSSIBLE;
    },

    isSeatReservation() {
        return this.seats.size > 0;
    },

    isBikeReservation() {
        return this.bikeSeats.size > 0;
    },
});

ReservationLeg.fromJSON = function(json) {
    return construct(ReservationLeg, json, {
        arrival: fields.string,
        departure: fields.string,
        origin: resolve.as(ReservationStation),
        destination: resolve.as(ReservationStation),
        retailServiceId: fields.string,
        seats: resolveAll.as(ReservationSeat),
        bikeSeats: resolveAll.as(ReservationSeat),
        supplement: fields.string,
        ticketType: fields.string,
        seatReservation: fields.string,
        bikeSeatReservation: fields.string,
    });
};

export default ReservationLeg;
